import { render } from "./AddDeviceToGroupDialog.vue?vue&type=template&id=1b3873ad"
import script from "./AddDeviceToGroupDialog.vue?vue&type=script&lang=js"
export * from "./AddDeviceToGroupDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__